import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/arrow-left.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M11.293 4.29295C11.6835 3.90243 12.3166 3.90243 12.7071 4.29295C13.0976 4.68348 13.0976 5.31649 12.7071 5.70702L7.41411 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.41411L12.7071 18.293L12.7754 18.3691C13.0958 18.7619 13.0732 19.3409 12.7071 19.707C12.341 20.0731 11.762 20.0957 11.3692 19.7754L11.293 19.707L4.29302 12.707C3.90249 12.3165 3.90249 11.6835 4.29302 11.293L11.293 4.29295Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ArrowLeftIcon };
